import { Link } from '@tanstack/react-router';
import { memo } from 'react';
import BetaBadgeV2 from 'src/shared/components/ui/badges/beta-badge-v2';
import DynamicIcon, { Icons } from 'src/shared/components/ui/icons/dynamic-icon';
import { cn } from 'src/shared/lib/utils';

type NavigationTabProps = {
  icon?: Icons;
  text: string;
  href: string;
  badge?: string;
  isActive: boolean;
} & WithTestId;

function NavigationTabComponent({ icon, text, href, badge, isActive, testId }: NavigationTabProps) {
  return (
    <Link to={href}>
      <button
        className={cn(
          'flex items-center gap-2 py-2 px-2 mb-0.5 text-typography-grey  transition-colors text-[14px] whitespace-nowrap font-light',
          isActive ? 'text-primary' : 'hover:text-typography-darkgrey'
        )}
        data-testid={testId}
      >
        {icon && <DynamicIcon name={icon} size={16} />}
        {text}
        {badge && <BetaBadgeV2 text={badge} />}
      </button>

      <div className={cn('w-full h-[1px]', isActive && 'bg-primary')} />
    </Link>
  );
}

const NavigationTab = memo(
  NavigationTabComponent,
  (prev, next) =>
    prev.isActive === next.isActive &&
    prev.href === next.href &&
    prev.text === next.text &&
    prev.icon === next.icon &&
    prev.badge === next.badge &&
    prev.testId === next.testId
);

export default NavigationTab;
